import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SelectOption from './SelectOption';
import { SPECIFIED_FOR_GEORGIA_PACKAGES, TRAVEL_LIMITS } from '../../../../constants/travelCalcConstants';
import Currency from '../../../Currency';

import UmbrellaIcon from '../../../../img/umbrella.svg';
import SpecialPriceBackground from '../../../../img/specialPrice.svg';
import useStyles from './makeStyles';

const GeorgiaSpecialPriceAlert = ({
  selectedPackage,
  handlePackageChange,
  setShowAlert,
  setSelectedPackage,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const onClose = useCallback(() => {
    setShowAlert(false);
    setSelectedPackage({});
  }, [setSelectedPackage, setShowAlert]);

  return (
    <Grid
      container
      className={classes.container}
    >
      <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
        <CloseIcon className={classes.icon} />
      </IconButton>
      <div className={classes.specialPriceBackground}>
        <img alt="special price" src={SpecialPriceBackground} />
      </div>
      <div className={classes.specialPrice}>
        <span
          dangerouslySetInnerHTML={{
            __html: t('travelContract.specialPrice'),
          }}
        />
      </div>
      {SPECIFIED_FOR_GEORGIA_PACKAGES.map((item, index) => (
        <React.Fragment key={item.value}>
          <Grid item md={4} sm={12} className={classes.gridItem}>
            <SelectOption
              item={item}
              selectedPackage={selectedPackage}
              handlePackageChange={handlePackageChange}
            />
          </Grid>
          {index === 0
            && (
              <Grid item md={2} sm={12} className={classes.gridItem}>
                <img alt="umbrella" src={UmbrellaIcon} className={classes.umbrella} />
              </Grid>
            )}
        </React.Fragment>
      ))}
      <div className={classes.insuranceCoveragePrice}>
        {t('travel.georgiaInsurancePrice')}
        <b>
          <Currency
            value={TRAVEL_LIMITS['50kEur'].value}
            currency={TRAVEL_LIMITS['50kEur'].currency}
            withSymbol
          />
        </b>
      </div>
    </Grid>
  );
};

GeorgiaSpecialPriceAlert.propTypes = {
  selectedPackage: PropTypes.shape({
  }).isRequired,
  setSelectedPackage: PropTypes.func.isRequired,
  handlePackageChange: PropTypes.func.isRequired,
  setShowAlert: PropTypes.func.isRequired,
};

export default GeorgiaSpecialPriceAlert;
